.container {
  padding: 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  @media screen and (min-width: $bp-medium) {
    gap: 3.2rem;
  }
}
